/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {dlsColor} from '../../../theme/theme';

/**
 * The card width every Asset Details Drawer card/accordion shares
 * (ION-7461). Fills its container rather than a fixed 456px, so the cards
 * match the 456px drawer on desktop and the full screen width on mobile
 * (a fixed 456px overflowed the ~390px mobile sheet horizontally).
 *
 * ```typescript
 *
 *   import {ASSET_DETAILS_CARD_WIDTH} from
 *     '@ion/dls/src/components/assetdetails/current/assetDetailsAccordionStyles';
 *   ...
 *
 *   const useStyles = makeStyles(() => ({
 *     wrapper : {
 *       boxSizing : 'border-box',
 *       width     : ASSET_DETAILS_CARD_WIDTH
 *     }
 *   }));
 *
 * ```
 */
export const ASSET_DETAILS_CARD_WIDTH = '100%';

/**
 * The 2px teal top border every Asset Details Drawer accordion's header
 * gets, separating it from the card above it - shared here since every
 * current-theme accordion (Additional Info, Diagnostics, Spreader, Tags,
 * Vision) declared this identical rule independently.
 *
 * ```typescript
 *
 *   import {getAccordionTopBorderStyle} from
 *     '@ion/dls/src/components/assetdetails/current/assetDetailsAccordionStyles';
 *   ...
 *
 *   const useStyles = makeStyles(() => ({
 *     header : getAccordionTopBorderStyle()
 *   }));
 *
 * ```
 *
 * @returns The `boxSizing`/`borderTop` style object for an accordion header
 */
export const getAccordionTopBorderStyle = () => ({
  boxSizing : 'border-box' as const,
  borderTop : `2px solid ${dlsColor('pastelTeal')}`
});
